/**
 * device-utils.js - this file defines components vital for creating seamless responsive experience
 */

import React from 'react';
import Media from 'react-media';
import PropTypes from 'prop-types';

import { MEDIA_QUERY } from 'common/consts/media-query';

/**
 * <OnDesktop /> - renders its contents only when media query falls in "desktop" constraint
 */
class OnDesktop extends (() => React.PureComponent)() {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  render() {
    return (
      <Media
        query={`(min-width: ${MEDIA_QUERY.MOBILE_THRESHOLD_WIDTH +
          1}px) and (min-height: ${MEDIA_QUERY.MOBILE_THRESHOLD_HEIGHT + 1}px)`}
      >
        <div>{this.props.children}</div>
      </Media>
    );
  }
}

/**
 * <OnMobile /> - renders its contents only when media query falls in "mobile" constraint
 */
class OnMobile extends (() => React.PureComponent)() {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  render() {
    return (
      <Media
        query={`(max-width: ${
          MEDIA_QUERY.MOBILE_THRESHOLD_WIDTH
        }px), (max-height: ${MEDIA_QUERY.MOBILE_THRESHOLD_HEIGHT}px)`}
      >
        <div>{this.props.children}</div>
      </Media>
    );
  }
}

const isOnMobile = () => {
  const query = window.matchMedia(
    `(max-width: ${MEDIA_QUERY.MOBILE_THRESHOLD_WIDTH}px)`
  );

  return query.matches;
};

export { isOnMobile };
export { OnDesktop };
export { OnMobile };



// WEBPACK FOOTER //
// ./src/utils/device-utils.js